// ADV-268 — Profil "Sicherheit" tab per Figma "KONTO | 06 Profil · Sicherheit" (desktop
// 64199:8098, mobile 64199:8166): heading, the three password fields (one row on desktop,
// stacked on mobile), the password hint and the actions. Styles: ../ProfilePage.css (.pf-).
// Same CredentialsForm bindings, button states and onConfirm/onDecline callbacks as before.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import CredentialsForm from '../forms/CredentialsForm';
import { FormField } from '@bytebrand/fe-ui-core-autobahn/ui';
let ProfileTabSecurityNext = class ProfileTabSecurityNext extends React.Component {
    constructor() {
        super(...arguments);
        // auto.de / Field MD3: our notched label on the outline; while the field is empty (and not
        // focused) it rests inside, as in Figma's "Empty" state
        Object.defineProperty(this, "renderField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (field, id, label) => (React.createElement("div", { className: classNames('pf-field', { 'is-empty': !field.value }) },
                React.createElement("label", { className: 'pf-label', htmlFor: id }, label),
                React.createElement(FormField, { field: field, t: this.props.t, id: id, type: 'password', autoComplete: 'off', hideLabel: true })))
        });
    }
    render() {
        const { t, onConfirm, onDecline, isChangePassword } = this.props;
        const passFieldOld = CredentialsForm.$('oldPassword');
        const passField = CredentialsForm.$('changePassword.password');
        const passField2 = CredentialsForm.$('changePassword.password2');
        const buttonDisabledCancel = !passField.changed && !passFieldOld.changed;
        const buttonDisabled = !passField.changed || !passFieldOld.changed || !passField2.changed
            || !passField.isValid || !passFieldOld.isValid || !passField2.isValid;
        const buttonLoading = CredentialsForm.validating || CredentialsForm.submitting || isChangePassword;
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: 'pf-title' }, t('forms.changePassword')),
            React.createElement("div", { className: 'pf-password-form' },
                React.createElement("div", { className: 'pf-row' },
                    this.renderField(passFieldOld, 'pf-oldPassword', t('securityForm.oldPassword')),
                    this.renderField(passField, 'pf-newPassword', t('securityForm.newPassword')),
                    this.renderField(passField2, 'pf-newPassword2', t('securityForm.confirmPassword')))),
            React.createElement("p", { className: 'pf-hint' }, t('securityForm.hint')),
            React.createElement("div", { className: 'pf-security-actions' },
                React.createElement("button", { type: 'button', className: 'pf-btn pf-btn--outlined', onClick: onDecline, disabled: buttonDisabledCancel }, t('forms.cancel')),
                React.createElement("button", { type: 'button', className: 'pf-btn pf-btn--filled', onClick: onConfirm, disabled: buttonDisabled || buttonLoading }, t('forms.saveChanges')))));
    }
};
ProfileTabSecurityNext = __decorate([
    observer
], ProfileTabSecurityNext);
export default ProfileTabSecurityNext;
